import { render } from "./Library.vue?vue&type=template&id=4fe06c36"
import script from "./Library.vue?vue&type=script&lang=js"
export * from "./Library.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\csit142\\source\\repos\\Website.TorbayDesignGuide\\Website.TorbayDesignGuide.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__